import React, { Component } from 'react';
import { About } from './About';
import { Contact } from './Contact';


export class Home extends Component {
    static displayName = Home.name;

 
    render() {

    return (
        <div>

            {/* Services 
            <Services />*/ }

            {/* Portfolio Grid 
            <Portfolio />*/}
            {/*  Portfolio Modals */}

            {/* About */}
            <About />

            {/* Team 
            <Team />
*/ }
            {/*  contact            <Clients />
*/ }
            {/* Contact */ }
            <Contact />


        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js